import { HeaderTitle } from "../HeaderTitle";
import { useIsLocationAllowed } from "@/hooks/useIsLocationAllowed";


export function Footer() {
  const [isLocationAllowed] = useIsLocationAllowed();

  return (
    <div className="text-white pt-6">
      <div className="flex justify-between items-center mb-4">
        <HeaderTitle />
        <div className="text-lg font-medium text-right opacity-75 ml-6 hover:opacity-100 transition-all duration-300">
          The official app for skilled scratch offs
        </div>
      </div>
      
      <p className="text-lg mb-6 opacity-75 hover:opacity-100 transition-all duration-300">
        {`We take compliance and responsible gaming seriously. You must be 18+ and in ${isLocationAllowed?.locationName}. 
        Scratch has been statistically analyzed for state compliance and requires active geolocation at all times.`}
      </p>
      
      <div className="text-lg opacity-75 hover:opacity-100 transition-all duration-300">
        All rights reserved © 2025
      </div>
    </div>
  );
};